import expire from 'store/plugins/expire';
import store from 'store';
export const cache = store;
cache.addPlugin(expire);
cache.memoize = ({ url, fn, secondsOfCache = 0 }) => {
    const result = cache.get(url);
    if (!result) {
        return fn(url).then((resp) => {
            cache.set(url, resp, new Date().getTime() + secondsOfCache * 1000);
            return resp;
        });
    }
    return Promise.resolve(result);
};
//# sourceMappingURL=index.js.map